// collection-data-legend.ts
// The ?__debug__ legend: one pill per source the page's images came through.

import './collection-data-legend.scss';

/** One image source the page drew from: an item, a field, and its depth. */
export interface LegendEntry {
  itemName: string;
  fieldName: string;
  depth: number;
}

const CONTAINER_CLASS = 'cms-debug-legend';
const TITLE_CLASS = 'cms-debug-legend__title';
const PILL_CLASS = 'cms-debug-legend__pill';

/** The pill of each depth, in the outline colors. Other depths get none. */
const DEPTH_CLASS: Record<number, string> = {
  1: 'cms-debug-legend__pill--one-deep',
  2: 'cms-debug-legend__pill--two-deep'
};

const ARROW = ' → ';

/**
 * A CMS display name, without its parenthetical: `P-INTERIOR Gallery -
 * (up to 25 Images)` reads `P-INTERIOR Gallery` on a pill. Whatever
 * trailing spaces or dashes the cut leaves behind go with it.
 */
const cleanName = (name: string): string =>
  name
    .replace(/\([^)]*\)/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/[\s-]+$/, '')
    .trim();

/**
 * Pin the legend to the corner and add one pill per item→field pair,
 * however many images rode it. Calling again adds only what is new, so
 * every source of the page shares the one legend.
 */
export function renderLegend(entries: LegendEntry[]): void {
  const withDepth = entries.filter((entry) => DEPTH_CLASS[entry.depth]);

  if (!withDepth.length) return;

  let found = document.querySelector<HTMLElement>(`.${CONTAINER_CLASS}`);

  if (!found) {
    found = document.createElement('div');
    found.className = CONTAINER_CLASS;

    const title = document.createElement('div');

    title.className = TITLE_CLASS;
    title.textContent = 'DEBUGGER';
    found.append(title);

    document.body.append(found);
  }

  const legend = found;
  const pills = () => Array.from(legend.querySelectorAll(`.${PILL_CLASS}`));

  withDepth.forEach((entry) => {
    const label = `${cleanName(entry.itemName)}${ARROW}${cleanName(entry.fieldName)}`;
    const exists = pills().some((pill) => pill.textContent === label);

    if (exists) return;

    const pill = document.createElement('span');

    pill.className = `${PILL_CLASS} ${DEPTH_CLASS[entry.depth]}`;
    pill.textContent = label;
    legend.append(pill);
  });
}
